import { Link } from "react-router-dom";
import { hasValidToken } from "../utils/session";
import "./Landing.css";

/* Shared inline SVG bits */
const ArrowRight = ({ color = "#FAFAF9", size = 15 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        stroke={color}
        strokeWidth="1.6"
    >
        <path d="M2 8h11M9 3.5 13.5 8 9 12.5" />
    </svg>
);

const Check = () => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 16 16"
        fill="none"
        stroke="#1E6B4F"
        strokeWidth="1.8"
    >
        <path d="M2.5 8.5 6 12l7.5-8" />
    </svg>
);

const FlowArrow = () => (
    <div className="ml-flow-arrow">
        <svg
            width="28"
            height="16"
            viewBox="0 0 28 16"
            fill="none"
            stroke="#8B8781"
            strokeWidth="1.5"
        >
            <path d="M0 8h24M20 3l5 5-5 5" />
        </svg>
    </div>
);

function PipelineDiagram() {
    return (
        <svg width="720" height="300" viewBox="0 0 720 300" fill="none">
            <defs>
                <marker
                    id="ah1"
                    markerWidth="8"
                    markerHeight="8"
                    refX="7"
                    refY="4"
                    orient="auto"
                >
                    <path
                        d="M0 0.5 7 4 0 7.5"
                        fill="none"
                        stroke="#8B8781"
                        strokeWidth="1.4"
                    />
                </marker>
                <marker
                    id="ah2"
                    markerWidth="8"
                    markerHeight="8"
                    refX="7"
                    refY="4"
                    orient="auto"
                >
                    <path
                        d="M0 0.5 7 4 0 7.5"
                        fill="none"
                        stroke="#1E6B4F"
                        strokeWidth="1.6"
                    />
                </marker>
            </defs>
            <path
                d="M172 56 H222"
                stroke="#8B8781"
                strokeWidth="1.4"
                markerEnd="url(#ah1)"
            />
            <path
                d="M404 56 H454"
                stroke="#1E6B4F"
                strokeWidth="1.8"
                markerEnd="url(#ah2)"
            />
            <path
                d="M540 88 C540 160 420 150 404 210"
                stroke="#8B8781"
                strokeWidth="1.4"
                markerEnd="url(#ah1)"
            />
            <path
                d="M312 88 C312 170 140 150 118 208"
                stroke="#B8B5AF"
                strokeWidth="1.4"
                strokeDasharray="5 5"
                markerEnd="url(#ah1)"
            />
            <rect
                x="0"
                y="24"
                width="172"
                height="64"
                rx="5"
                fill="#FFFFFF"
                stroke="#C9C6C0"
            />
            <rect
                x="232"
                y="24"
                width="172"
                height="64"
                rx="5"
                fill="#FFFFFF"
                stroke="#C9C6C0"
            />
            <rect
                x="464"
                y="24"
                width="172"
                height="64"
                rx="5"
                fill="#FFFFFF"
                stroke="#1E6B4F"
                strokeWidth="1.6"
            />
            <rect
                x="232"
                y="210"
                width="172"
                height="64"
                rx="5"
                fill="#F3F8F5"
                stroke="#1E6B4F"
            />
            <rect
                x="32"
                y="210"
                width="150"
                height="64"
                rx="5"
                fill="#F5F4F2"
                stroke="#C9C6C0"
                strokeDasharray="4 4"
            />
            <text
                x="20"
                y="50"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="10"
                letterSpacing="1.5"
                fill="#8B8781"
            >
                STAGE 01
            </text>
            <text
                x="20"
                y="70"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="15"
                fontWeight="600"
                fill="#171715"
            >
                New enquiry
            </text>
            <text
                x="252"
                y="50"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="10"
                letterSpacing="1.5"
                fill="#8B8781"
            >
                STAGE 02
            </text>
            <text
                x="252"
                y="70"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="15"
                fontWeight="600"
                fill="#171715"
            >
                Qualified
            </text>
            <text
                x="484"
                y="50"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="10"
                letterSpacing="1.5"
                fill="#1E6B4F"
            >
                STAGE 03
            </text>
            <text
                x="484"
                y="70"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="15"
                fontWeight="600"
                fill="#171715"
            >
                Proposal sent
            </text>
            <text
                x="252"
                y="236"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="10"
                letterSpacing="1.5"
                fill="#1E6B4F"
            >
                STAGE 04
            </text>
            <text
                x="252"
                y="256"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="15"
                fontWeight="600"
                fill="#171715"
            >
                Won
            </text>
            <text
                x="52"
                y="236"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="10"
                letterSpacing="1.5"
                fill="#8B8781"
            >
                ANY STAGE
            </text>
            <text
                x="52"
                y="256"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="15"
                fontWeight="600"
                fill="#6E6B66"
            >
                Lost
            </text>
            <rect x="386" y="14" width="86" height="24" rx="12" fill="#1E6B4F" />
            <text
                x="400"
                y="30"
                fontFamily="Hanken Grotesk, sans-serif"
                fontSize="11"
                fontWeight="600"
                fill="#FFFFFF"
            >
                2 guards
            </text>
        </svg>
    );
}

/** Public marketing page at "/". */
export default function Landing() {
    const authed = hasValidToken();

    return (
        <div className="tessera-landing">
            <div className="ml-container">
                {/* ======= NAV ======= */}
                <nav className="ml-nav">
                    <div className="ml-wordmark">
                        <span className="ml-name">tessera</span>
                        <span className="ml-tag">CRM PLATFORM</span>
                    </div>
                    <div className="ml-nav-links">
                        <a href="#product">PRODUCT</a>
                        <a href="#solutions">SOLUTIONS</a>
                        <a href="#developers">DEVELOPERS</a>
                        <a href="#pricing">PRICING</a>
                    </div>
                    <div className="ml-nav-actions">
                        {authed ? (
                            <Link to="/dashboard" className="ml-signin-link">
                                Open app
                            </Link>
                        ) : (
                            <Link to="/signin" className="ml-signin-link">
                                Sign in
                            </Link>
                        )}
                        <Link to="/signup" className="ml-btn-dark ml-btn-sm">
                            GET STARTED
                            <ArrowRight size={14} />
                        </Link>
                    </div>
                </nav>

                {/* ======= HERO ======= */}
                <header className="ml-hero" id="product">
                    <div className="ml-kicker">
                        <span className="ml-rule" />
                        THE CRM YOU BUILD, NOT BUY
                        <span className="ml-rule" />
                    </div>
                    <h1 className="ml-hero-title">
                        A CRM that takes
                        <br />
                        the shape of <em>your</em> business.
                    </h1>
                    <p className="ml-hero-sub">
                        Tessera is a blank canvas. Define your own objects,
                        roles, pipelines and automations — visually, in
                        minutes. No code. No consultants. No compromises.
                    </p>
                    <div className="ml-hero-ctas">
                        <Link to="/signup" className="ml-btn-dark">
                            Start building — it&#39;s free
                            <ArrowRight />
                        </Link>
                        <button type="button" className="ml-btn-outline">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                stroke="#171715"
                                strokeWidth="1.5"
                            >
                                <circle cx="8" cy="8" r="6.5" />
                                <path
                                    d="M6.5 5.5v5l4-2.5z"
                                    fill="#171715"
                                    stroke="none"
                                />
                            </svg>
                            Watch the tour
                        </button>
                    </div>
                </header>

                {/* ======= STAT TILES ======= */}
                <section className="ml-stats">
                    <div className="ml-stat">
                        <span className="ml-stat-value">100%</span>
                        <span className="ml-stat-label">NO-CODE</span>
                    </div>
                    <div className="ml-stat">
                        <span className="ml-stat-value">&#8734;</span>
                        <span className="ml-stat-label">CUSTOM ROLES</span>
                    </div>
                    <div className="ml-stat">
                        <span className="ml-stat-value">20+</span>
                        <span className="ml-stat-label">FIELD TYPES</span>
                    </div>
                    <div className="ml-stat">
                        <span className="ml-stat-value">API</span>
                        <span className="ml-stat-label">ON EVERY OBJECT</span>
                    </div>
                </section>

                {/* ======= BUILD YOUR OWN ======= */}
                <section className="ml-build" id="solutions">
                    <div className="ml-build-head">
                        <div className="ml-build-head-copy">
                            <div className="ml-kicker">
                                <span className="ml-dot" />
                                BUILD YOUR OWN
                            </div>
                            <h2 className="ml-h2">
                                Your business isn&#39;t a template.
                                <br />
                                Your CRM shouldn&#39;t be either.
                            </h2>
                        </div>
                        <Link to="/signup" className="ml-explore-link">
                            EXPLORE THE BUILDER
                            <ArrowRight color="#171715" size={14} />
                        </Link>
                    </div>
                    <div className="ml-cards-3">
                        <div className="ml-card">
                            <svg
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#171715"
                                strokeWidth="1.4"
                            >
                                <rect x="3" y="3" width="8" height="8" rx="1" />
                                <rect x="13" y="3" width="8" height="8" rx="1" />
                                <rect x="3" y="13" width="8" height="8" rx="1" />
                                <rect
                                    x="13"
                                    y="13"
                                    width="8"
                                    height="8"
                                    rx="1"
                                />
                            </svg>
                            <div className="ml-card-title">
                                Custom objects &amp; fields
                            </div>
                            <div className="ml-card-body">
                                Leads and deals are just the start. Create any
                                object your process needs — site visits,
                                franchise applications, renewals — with 20+
                                field types, validation and lookups between
                                them.
                            </div>
                        </div>
                        <div className="ml-card">
                            <svg
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#171715"
                                strokeWidth="1.4"
                            >
                                <circle cx="12" cy="8" r="3.5" />
                                <path d="M4.5 20c.8-3.5 3.8-5.5 7.5-5.5s6.7 2 7.5 5.5" />
                                <path
                                    d="M17.5 3.5 19 5l2.5-2.5"
                                    stroke="#1E6B4F"
                                />
                            </svg>
                            <div className="ml-card-title">
                                Roles written by you
                            </div>
                            <div className="ml-card-body">
                                Create any role and decide exactly what it sees
                                and does — down to a single field. Scopes for
                                own, team and organisation, with a hierarchy
                                that mirrors yours.
                            </div>
                        </div>
                        <div className="ml-card">
                            <svg
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#171715"
                                strokeWidth="1.4"
                            >
                                <rect
                                    x="3"
                                    y="4"
                                    width="18"
                                    height="14"
                                    rx="1.5"
                                />
                                <path d="M3 9h18M8 4v5" />
                            </svg>
                            <div className="ml-card-title">
                                Many apps, one workspace
                            </div>
                            <div className="ml-card-body">
                                Run Sales, Support and Recruitment as separate
                                apps in one organisation — each with its own
                                objects, pipelines and automations, sharing the
                                data that should be shared.
                            </div>
                        </div>
                    </div>
                </section>

                {/* ======= PIPELINE SHOWCASE ======= */}
                <section className="ml-pipeline">
                    <div className="ml-pipeline-copy">
                        <div className="ml-kicker">
                            <span className="ml-dot ml-dot-green" />
                            VISUAL PIPELINES
                        </div>
                        <h2 className="ml-h2">
                            Draw your process.
                            <br />
                            The platform <em>obeys.</em>
                        </h2>
                        <p className="ml-body-copy">
                            Drag stages onto the canvas and connect them with
                            arrows. Every arrow can carry rules — required
                            fields, who may move a deal, and what happens
                            automatically when it moves.
                        </p>
                        <div className="ml-checks">
                            <div className="ml-check">
                                <Check />
                                Guards — &#8220;can&#39;t advance without a
                                budget&#8221;
                            </div>
                            <div className="ml-check">
                                <Check />
                                Role-gated moves — only managers close deals
                            </div>
                            <div className="ml-check">
                                <Check />
                                Actions on every transition — tasks, emails,
                                webhooks
                            </div>
                        </div>
                    </div>
                    <div className="ml-canvas">
                        <PipelineDiagram />
                    </div>
                </section>

                {/* ======= AUTOMATION ======= */}
                <section className="ml-automation">
                    <div className="ml-automation-head">
                        <div className="ml-kicker">
                            <span className="ml-dot" />
                            AUTOMATION
                        </div>
                        <h2 className="ml-h2">
                            Workflows that run while
                            <br />
                            your team sells.
                        </h2>
                        <p className="ml-automation-sub">
                            Compose any automation from three parts. Your
                            rules, your conditions, your language — assembled
                            visually, executed reliably.
                        </p>
                    </div>
                    <div className="ml-flow">
                        <div className="ml-flow-card">
                            <div className="ml-flow-kicker">WHEN</div>
                            <div className="ml-flow-title">A trigger fires</div>
                            <div className="ml-flow-body">
                                A record is created, a field changes, a stage
                                moves, a form is submitted — or simply every
                                Monday at 9am.
                            </div>
                            <div className="ml-pills">
                                <span className="ml-pill">Lead created</span>
                                <span className="ml-pill">Stage changed</span>
                                <span className="ml-pill">Every Monday</span>
                            </div>
                        </div>
                        <FlowArrow />
                        <div className="ml-flow-card">
                            <div className="ml-flow-kicker">IF</div>
                            <div className="ml-flow-title">
                                Your conditions match
                            </div>
                            <div className="ml-flow-body">
                                Nest any/all groups over your own fields. The
                                same condition language powers validation,
                                routing and scoring.
                            </div>
                            <div className="ml-code-inline">
                                source <span className="g">is</span>{" "}
                                &#8220;website&#8221;
                                <br />
                                <span className="m">and</span> budget{" "}
                                <span className="g">&gt;</span> 1,00,000
                            </div>
                        </div>
                        <FlowArrow />
                        <div className="ml-flow-card">
                            <div className="ml-flow-kicker">THEN</div>
                            <div className="ml-flow-title">
                                Actions run for you
                            </div>
                            <div className="ml-flow-body">
                                Assign round-robin, create tasks, send
                                templated email, notify the owner, call a
                                webhook — in the order you choose.
                            </div>
                            <div className="ml-pills">
                                <span className="ml-pill">Assign owner</span>
                                <span className="ml-pill">Send email</span>
                                <span className="ml-pill">Webhook</span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ======= DEVELOPERS ======= */}
                <section className="ml-dev" id="developers">
                    <div className="ml-dev-copy">
                        <div className="ml-kicker">
                            <span className="ml-dot" />
                            FOR DEVELOPERS
                        </div>
                        <h2 className="ml-h2">
                            Every object you create ships with an API.
                        </h2>
                        <p className="ml-dev-sub">
                            The moment you define an object, its REST endpoints
                            exist. Generate scoped tokens bound to your own
                            roles, push leads from your website, and subscribe
                            to signed webhooks — no integration project
                            required.
                        </p>
                        <div className="ml-dev-feats">
                            <div className="ml-dev-feat">
                                <span className="t">Role-bound tokens</span>
                                <span className="d">
                                    A key can do exactly what its role can.
                                </span>
                            </div>
                            <div className="ml-dev-feat">
                                <span className="t">Signed webhooks</span>
                                <span className="d">
                                    HMAC payloads, retries built in.
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="ml-terminal">
                        <div className="ml-terminal-bar">
                            <div className="ml-terminal-dots">
                                <span />
                                <span />
                                <span />
                            </div>
                            <span className="ml-terminal-name">
                                create-lead.sh
                            </span>
                        </div>
                        <div className="ml-terminal-body">
                            {"curl -X POST https://api.tessera.crm/v1/sales/leads/records \\\n  -H "}
                            <span className="g">
                                &quot;Authorization: Bearer
                                tessera_live_&#8226;&#8226;&#8226;&#8226;&quot;
                            </span>
                            {" \\\n  -d "}
                            <span className="g">
                                {"'{\n    \"name\":   \"Meera Constructions\",\n    \"source\": \"website\",\n    \"budget\": 250000\n  }'"}
                            </span>
                            {"\n\n"}
                            <span className="m">
                                # 201 Created — assignment rules already ran,
                            </span>
                            {"\n"}
                            <span className="m">
                                # the owner was notified, the workflow fired.
                            </span>
                        </div>
                    </div>
                </section>

                {/* ======= CTA ======= */}
                <section className="ml-cta" id="pricing">
                    <h2 className="ml-cta-title">
                        Ready for a CRM that
                        <br />
                        <em>finally</em> fits?
                    </h2>
                    <p className="ml-cta-sub">
                        Create your workspace and build your first app before
                        your next stand-up.
                    </p>
                    <Link to="/signup" className="ml-btn-dark">
                        Create your workspace
                        <ArrowRight />
                    </Link>
                </section>

                {/* ======= FOOTER ======= */}
                <footer className="ml-footer">
                    <div className="ml-footer-top">
                        <div className="ml-footer-brand">
                            <span className="ml-name">tessera</span>
                            <span className="ml-desc">
                                The flexible CRM platform. Built for teams who
                                refuse to work the way a template tells them
                                to.
                            </span>
                        </div>
                        <div className="ml-footer-cols">
                            <div className="ml-footer-col">
                                <span className="ml-col-head">PRODUCT</span>
                                <a href="#product">Objects &amp; fields</a>
                                <a href="#product">Roles &amp; permissions</a>
                                <a href="#product">Pipelines</a>
                                <a href="#product">Workflows</a>
                            </div>
                            <div className="ml-footer-col">
                                <span className="ml-col-head">DEVELOPERS</span>
                                <a href="#developers">API reference</a>
                                <a href="#developers">Webhooks</a>
                                <a href="#developers">Changelog</a>
                                <a href="#developers">Status</a>
                            </div>
                            <div className="ml-footer-col">
                                <span className="ml-col-head">COMPANY</span>
                                <a href="#product">About</a>
                                <a href="#pricing">Pricing</a>
                                <a href="#product">Contact</a>
                                <a href="#product">Careers</a>
                            </div>
                        </div>
                    </div>
                    <div className="ml-footer-bottom">
                        <span>
                            &#169; 2026 Optigrit. All rights reserved.
                        </span>
                        <div className="ml-footer-legal">
                            <a href="#product">Privacy</a>
                            <a href="#product">Terms</a>
                            <a href="#product">Security</a>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
}
